import React from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

export type HeaderProps = StylableComponent<HTMLDivElement>;

const Header = React.forwardRef<HTMLDivElement, HeaderProps>(
  ({ children, className, style, ...props }, ref) => {
    const headerTokens = useTheme().tokens?.component?.activityLog?.header;

    return (
      <div
        ref={ref}
        className={className}
        css={[headerTokens, style]}
        {...props}
      >
        {children}
      </div>
    );
  },
);

Header.displayName = 'Header';

Header.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Header content */
  children: PropTypes.any,
};

export default Header;
